/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SignalFindingsRequestBody,
  SignalFindingsRequestBody$Outbound,
  SignalFindingsRequestBody$outboundSchema,
} from "../components/signalfindingsrequestbody.js";

export type AnalyticsSignalFindingsSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type AnalyticsSignalFindingsRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  signalFindingsRequestBody: SignalFindingsRequestBody;
};

/** @internal */
export type AnalyticsSignalFindingsSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const AnalyticsSignalFindingsSecurity$outboundSchema: z.ZodMiniType<
  AnalyticsSignalFindingsSecurity$Outbound,
  AnalyticsSignalFindingsSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function analyticsSignalFindingsSecurityToJSON(
  analyticsSignalFindingsSecurity: AnalyticsSignalFindingsSecurity,
): string {
  return JSON.stringify(
    AnalyticsSignalFindingsSecurity$outboundSchema.parse(
      analyticsSignalFindingsSecurity,
    ),
  );
}

/** @internal */
export type AnalyticsSignalFindingsRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  SignalFindingsRequestBody: SignalFindingsRequestBody$Outbound;
};

/** @internal */
export const AnalyticsSignalFindingsRequest$outboundSchema: z.ZodMiniType<
  AnalyticsSignalFindingsRequest$Outbound,
  AnalyticsSignalFindingsRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    signalFindingsRequestBody: SignalFindingsRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      signalFindingsRequestBody: "SignalFindingsRequestBody",
    });
  }),
);

export function analyticsSignalFindingsRequestToJSON(
  analyticsSignalFindingsRequest: AnalyticsSignalFindingsRequest,
): string {
  return JSON.stringify(
    AnalyticsSignalFindingsRequest$outboundSchema.parse(
      analyticsSignalFindingsRequest,
    ),
  );
}
